module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Delete Event","description":"Do you want to delete the event:","scheduledAt":"Scheduled at","alert":"Event was deleted successfully!","btnDelete":"Yes, delete it now"},"es":{"title":"Eliminar Evento","description":"Quieres eliminar el evento:","scheduledAt":"Agendado para el","alert":"¡Evento fue eliminado satisfactoriamente!","btnDelete":"Sí, eliminar ahora"}}')
  delete Component.options._Ctor
}
